module.exports = __webpack_public_path__ + "img/101032.49ce8132.png";